// extracted by mini-css-extract-plugin
export var boxItems = "_71-1";
export var boxItemsLg = "_71-2";
export var button = "_71-7";
export var buttonHoverless = "_71-9";
export var buttonLg = "_71-8";
export var filterGroupBox = "_71-0";
export var icon = "_71-3";
export var iconSecondary = "_71-6";
export var iconWrapper = "_71-4";
export var iconWrapperLg = "_71-5";
export var truncatedLabel = "_71-a";